//#region src/modules/ServicePeriods/activity-evals/occurrence/cadence/cadence-slots.ts
var MAX_CADENCE_SLOTS = 96;
function cadenceSlotStarts(durationMinutes, cadenceMinutes) {
	if (cadenceMinutes < 1 || durationMinutes < 1) return [];
	const slots = [];
	let start = 0;
	while (start < durationMinutes && slots.length < MAX_CADENCE_SLOTS) {
		slots.push(start);
		start += cadenceMinutes;
	}
	return slots;
}
function cadenceSlotEnd(slotStart, cadenceMinutes, bufferMinutes, durationMinutes) {
	return Math.min(durationMinutes, slotStart + cadenceMinutes + Math.max(0, bufferMinutes));
}
//#endregion
export { cadenceSlotEnd, cadenceSlotStarts };

//# sourceMappingURL=cadence-slots.js.map